import React from 'react';

export const CONNECTIVITY_GURU_METRICS = {
    SIGNAL_STRENGTH: 'signalStrength',
    CHANNEL_CONGESTION: 'channelCongestion',
    DOWNLOAD_SPEED: 'downloadSpeed',
    UPLOAD_SPEED: 'uploadSpeed',
    CONNECTED_DEVICES: 'connectedDevices'
};

export interface ConnectivityHeatmapData {
    customerConsent: {
        clientConsentOn: string;
        isConsent: boolean;
    };
    heatmapLegend: HeatmapLegendEntry[];
    imageHeight: number;
    imageWidth: number;
    imageUrls: HeatmapImage[];
    pointOfInterest: PointOfInterest[];
    rssiMetrics: RssiMetric[];
    uniqueRequestId: string;
}

export interface HeatmapLegendEntry {
    color: string;
    rssi: number;
}

export interface RssiMetricData {
    coordinates: {x: number; y: number; z?: number};
    rssi: number;
    ssid?: string;
    bssid?: string;
    timestamp?: number;
}

export interface HeatmapImage {
    /** Optional BSSID for single access point heatmap */
    bssid?: string;
    /** Optional list of BSSIDs for combined heatmaps */
    bssids?: string[];
    /** SSID name (Wi-Fi network) */
    ssid?: string;
    /** Relative or full image URL */
    imageUrl: string;
    /** Wi-Fi frequency band (e.g. '2.4GHz', '5GHz') */
    frequency?: string;
    /** Type of image, e.g. 'ssid_heatmap', 'bssid_heatmap', 'preview', 'markers', etc. */
    type:
        | 'ssid_heatmap'
        | 'bssid_heatmap'
        | 'ssid_heatmap_clean'
        | 'bssid_heatmap_clean'
        | 'preview'
        | 'markers'
        | 'roomplan'
        | string;
    /** RSSI scan metrics for heatmap rendering */
    rssiMetrics?: RssiMetricData[];
}

export interface PointOfInterest {
    color: string;
    label: string;
    coordinates?: Coordinates;
    metrics?: {
        bssid: string;
        rssi: number;
        ssid: string;
        /** Wi-Fi frequency band of the point (e.g. '2.4GHz', '5GHz') */
        frequency?: string;
    };
    timestamp?: number;
    /** Point type, e.g. 'start' | 'end' | 'mesh' | 'manual' */
    type?: string;
}

export interface Coordinates {
    x: number;
    y: number;
}

export interface RssiMetric {
    bssid: string;
    ssid: string;
    rssi: number;
    coordinates: Coordinates;
    timestamp: number;
}

export interface ScanResultBoxData {
    label?: string;
    value?: string | number;
    unit?: string;
    icon: React.ReactNode;
    wifiPercent?: string | number;
    levelOfSupport?: number;
    onClick?: () => void;
}

export interface ThresholdConfig {
    enabled: boolean;
    critical: number;
    warning: number;
}

export type ConnectivityGuruThreshold = {
    signalStrength: ThresholdConfig;
    channelCongestion: ThresholdConfig;
    downloadSpeed: ThresholdConfig;
    uploadSpeed: ThresholdConfig;
    connectedDevices: ThresholdConfig;
    layers?: {
        enableFrequency?: boolean;
    };
};

export enum SpotLightLabels {
    download = 'Download',
    upload = 'Upload',
    signal = 'Signal',
    connectedDevices = 'Connected',
    channel = 'Channel'
}

export enum WifiAnalyzerMode {
    Session = 'session',
    History = 'history'
}
